import axios from "axios";
import { autocompletePremierCollectionsPath } from "../paths";

import { config } from "../../config";
import { ICategorizedResponse } from "redmond";

export const fetchPCLocationAutocomplete = (
  query: string,
  locale = "en_US"
): Promise<{ categories: ICategorizedResponse[] }> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.get(autocompletePremierCollectionsPath, {
        baseURL: config.baseURL,
        params: { q: query, locale },
      });

      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });
